import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	overlay: {
		backgroundColor : "rgba(0, 0, 0, 0.55)",
		inset           : "0",
		position        : "absolute",
		display         : "none",
		zIndex          : "5"
	},
	overlayShow: {
		backgroundColor : "rgba(0, 0, 0, 0.55)",
		inset           : "0",
		position        : "absolute",
		display         : "block",
		zIndex          : "5"
	}
} );